import React, { Component } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import styled from 'styled-components'
import Text from '../components/Text'

const A = styled.a`
  color: var(--${props => props.color || 'blue'});
  text-decoration: none;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`

const LinkElt = A.withComponent(RouterLink)

export default class Link extends Component {
  render() {
    const { str, ...props } = this.props

    if (props.href) {
      return (
        <A {...props}>
          <Text str={str} />
        </A>
      )
    } else { 
      return (
        <LinkElt {...props}>
          <Text str={str} />
        </LinkElt>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Link.js